import { ReturnItem } from 'services/api/refund';
import { useTranslate } from '@tolgee/react';
import { DetailCard } from '../DetailCard';
import { OrderProduct } from '../OrderCard/OrderProduct';
import { getOrderProductPropsFromReturnItem } from 'components/LightConversation/utils/order';
import toLowerCase from 'utils/toLowerCase';
import { formatNumber } from 'utils/numberFormat';

interface OrderReturnItemsProps {
  platform: General.PlatformUpperCase;
  refundAmount: number;
  unit: string;
  returnItems: ReturnItem[];
}

export const OrderReturnItems = (props: OrderReturnItemsProps) => {
  const { platform, unit, returnItems, refundAmount } = props;
  const { t } = useTranslate();
  return (
    <DetailCard
      title={t('x个商品', { count: returnItems.length })}
      rightExtra={
        <div className="text-[16px] text-[#232426] font-medium">
          {t('ViewRefund.退款总金额')}:{unit} {formatNumber(refundAmount, '0,0.00')}
        </div>
      }
    >
      <div className="flex flex-col gap-3 bg-[#F7F9FA] rounded p-3">
        {returnItems.map((item) => {
          const dataProps = getOrderProductPropsFromReturnItem(item);
          return (
            <div key={item.itemId}>
              <OrderProduct
                {...dataProps}
                platform={toLowerCase(platform)}
                unit={unit}
                simple={false}
              />
            </div>
          );
        })}
      </div>
    </DetailCard>
  );
};
